__turbopack_context__.v({
  "mainButton": "k1E5ea_mainButton",
});
